import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { Subject } from 'rxjs';

import { FormGroup } from '@angular/forms';
import { FormControlOption } from '../../definition/interface/formControlOption.interface';
import { knowledgeOptions } from '../../services/ref';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
@Component({
    selector: 'financial-knowledge1-form',
    templateUrl: './financial-knowledge1-form.component.html',
    styleUrls: ['./financial-knowledge1-form.component.scss'],
    standalone: false
})
export class FinancialKnowledge1FormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options: FormControlOption[] = knowledgeOptions;
  options1: FormControlOption[] = [
    {
      value: true,
      label: 'Oui',
      suffix: { title: 'A' },
    },
    {
      value: false,
      label: 'Non',
      suffix: { title: 'B' },
    },
  ];
  optionsManagementMode: FormControlOption[] = [
    {
      value: 'YOURSELF',
      label: 'Directe',
    },
    {
      value: 'ADVISOR',
      label: 'Conseillée',
    },
    {
      value: 'UNDER_MANDATE',
      label: 'Sous mandat',
    },
  ];
  subscriptions: any[] = [];

  doneSubject: Subject<void> = new Subject<void>();
  page: number = 1;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }

  display(riskProfil: FormGroup, key: string) {
    const val = riskProfil.get(key)?.value;
    return !!val;
  }
}
